import React, { type ReactNode } from "react";

export interface ITermLinkProps {
  termClass?: string;
  url?: string;
  text?: string;
  children: ReactNode;
}

export default (props: ITermLinkProps) => {
  const { url, children } = props;

  // const handleTextPopup = useCallback(() => {
  //     const popup: Window | null = window.open("");
  //     if(!popup) {
  //         return;
  //     }
  //     popup.document.write(`<div style="white-space: pre-line; font-family: Arial">${text}</pre>`);
  // }, [text]);

  // if(termClass === "URL" || true) {
  return (
    <a href={url} target="_blank" rel="noreferrer">
      {children}
    </a>
  );
  // } else {
  //     return (
  //         <a href="###" onClick={handleTextPopup} target="_blank">
  //             {children}
  //         </a>
  //     );
  // }
};
